import axios from "@/utils/http";
import type { DbModelType, FormType } from "@/type";

export function getAppType() {
  return axios({
    url: "/codegen/metadata/appType",
    method: "GET",
  });
}

export function getModule(type: string) {
  return axios({
    url: `/codegen/metadata/${type}`,
    method: "GET",
  });
}

export function getAllDomain() {
  return axios({
    url: "/codegen//metadata/queryAllDomain",
    method: "GET",
  });
}

export function postTablesAll(
  data: Pick<DbModelType, "dbType" | "dbUrl" | "dbPassword" | "dbUserName">
) {
  return axios({
    url: "/db/table/all",
    method: "POST",
    data,
  });
}

export function postDownload(data: FormType) {
  return axios({
    url: "/codegen/download",
    method: "POST",
    data,
    responseType: "blob",
  });
}
